import React from 'react';
import { PapiUser } from '@wix/da-papi-types';
import { withTranslation, WithTranslation } from 'react-i18next';
import CommentThread from '@wix/da-shared-react/pkg/CommentThread';
import { CommentableTypes } from '@wix/da-shared-react/pkg/Comment/types';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';

export type Props = {
  profileOwnerUser: PapiUser;
  isOwner: boolean;
  isMobile: boolean;
  totalCount: number;
} & Pick<WidgetBoxProps, 'moduleId' | 'section' | 'zone'>;

export class ProfileCommentsBox extends React.Component<
  Props & WidgetBoxProps & WithTranslation
> {
  render() {
    const { widgetRemove, isMobile, section, zone, ...props } = this.props;

    return (
      <WidgetBox
        section={section}
        zone={zone}
        header={isMobile ? null : props.t!('widgets.profileComments.header')}
        count={isMobile ? undefined : props.totalCount}
        moduleId={props.moduleId}
        widgetRemove={widgetRemove}
        dataHook={BiDataHook.WIDGET_PROFILE_COMMENTS}
      >
        <div>
          <BiLoggerContextProvider
            value={{ widgetname: 'comments', sectionname: 'comments' }}
          >
            <CommentThread
              commentableTypeId={CommentableTypes.COMMENT_USER}
              commentableItemId={props.profileOwnerUser.userId}
              useCardLayout
              postbox="top"
              statsAndControls={isMobile ? 'on' : 'off'}
            />
          </BiLoggerContextProvider>
        </div>
      </WidgetBox>
    );
  }
}

export default withTranslation()(
  ProfileCommentsBox
) as React.ComponentType<Props>;
